import React from 'react'
import PropTypes from 'prop-types'
import {
  ComparisonRow,
  ComparisonCell,
  FeatureName,
  LastCompRow,
  FeatureEntryContainer,
  FeatureEntryText,
  FeatureEntryIcon,
  FeatureCell,
} from './styles'
import { theme } from '../builderUtils/theme'

export default function LPComparisonRow({
  featureName,
  hasBgColor,
  isLast,
  useSLIcon,
  slIconUrl,
  slEntryIcon,
  useSLText,
  slText,
  useCompIcon,
  compIconUrl,
  compEntryIcon,
  useCompText,
  compText,
}) {
  const Row = isLast ? LastCompRow : ComparisonRow

  return (
    <Row style={hasBgColor ? { background: theme.compareGray } : {}}>
      <FeatureCell>
        <FeatureName>{featureName}</FeatureName>
      </FeatureCell>
      <ComparisonCell>
        <FeatureEntryContainer>
          {useSLIcon && <FeatureEntryIcon src={slIconUrl} alt={`${slEntryIcon} icon`} />}
          {useSLText && <FeatureEntryText>{slText}</FeatureEntryText>}
        </FeatureEntryContainer>
      </ComparisonCell>
      <ComparisonCell>
        <FeatureEntryContainer>
          {useCompIcon && <FeatureEntryIcon src={compIconUrl} alt={`${compEntryIcon} icon`} />}
          {useCompText && <FeatureEntryText>{compText}</FeatureEntryText>}
        </FeatureEntryContainer>
      </ComparisonCell>
    </Row>
  )
}

LPComparisonRow.propTypes = {
  featureName: PropTypes.string.isRequired,
  hasBgColor: PropTypes.bool,
  isLast: PropTypes.bool,
  slIconUrl: PropTypes.string,
  slText: PropTypes.string,
  useSLIcon: PropTypes.bool,
  useCompIcon: PropTypes.bool,
  compIconUrl: PropTypes.string,
  compText: PropTypes.string,
  useSLText: PropTypes.bool,
  useCompText: PropTypes.bool,
  slEntryIcon: PropTypes.string,
  compEntryIcon: PropTypes.string,
}
